import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuInfinityIcon extends BaseIcon {
  getChildren = () => [
    <path
        d="M16.7 17.8C27 14.4 37 20 37 29.2c0 8.5-3.2 11.4-12.3 18.4 1.7.3 3.4.4 5.2.4C50.9 48 60 30 60 30s-8.5-17.9-30.1-17.9C9.6 12.1 1.4 26.8 0 29.6c5.2-4.9 11.3-10 16.7-11.8z"
        fill="#cc1e46"/>,
    <path fill="#a51339"
          d="M19.9 13.4C14.5 15 9.6 17.9 5.6 21.9c-2.3 2.3-4.1 4.9-5.6 7.7 5.2-4.9 11.3-9.9 16.7-11.8 4-1.4 8.1-1.3 11.5-.2 1.7-1.6 3.8-3.2 6.4-5.2-1.6-.3-3.3-.4-5-.4-3.3.1-6.5.5-9.7 1.4zM39.4 46.6c5.4-1.6 10.3-4.5 14.3-8.5 2.3-2.3 4.1-4.9 5.6-7.7-5.2 4.9-11.3 9.9-16.7 11.8-4 1.3-8.1 1.3-11.5.2-1.7 1.6-3.8 3.2-6.4 5.2 1.6.3 3.3.4 5 .4 3.3-.1 6.5-.5 9.7-1.4z"/>,
    <path
        d="M23.1 45.4c2.2-1.7 3.9-3 5.3-4.2-3.7-2.1-6.1-5.8-6.1-10.3 0-4.9 1.1-8 3.7-11-1-.2-2.1-.3-3.2-.3-1.8 0-3.6.3-5.3.9C12.3 22.2 6 27.7 1.8 31.7l-1.1.9c2.6 4 9 11.7 20.3 14.5l2.1-1.7z"
        fill="#e45785"/>
  ]
  getViewBox = () => '0 0 60 60'
}
